'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module = function () {
  function Module(el) {
    (0, _classCallCheck3.default)(this, Module);

    this.className = el.dataset.moduleClass;
    this.context = { context: el };
  }

  (0, _createClass3.default)(Module, [{
    key: 'getContextElement',
    value: function getContextElement(selector) {
      return (0, _functional.getElement)(selector, this.context);
    }
  }, {
    key: 'getContextElements',
    value: function getContextElements(selector) {
      return (0, _functional.getElements)(selector, this.context);
    }
  }, {
    key: 'bindMethods',
    value: function bindMethods() {
      var _this = this;

      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      methods.forEach(function (method) {
        return _this[method] = _this[method].bind(_this);
      });
    }
  }]);
  return Module;
}();

exports.default = Module;